import {Grid} from "@mui/material";
import './AnalysisSetting.css'
import fcs from "./images/fcs.png";
import clustering from "./images/clustering.png";
import meta from "./images/meta.png";
import anno from "./images/anno1.png";
import quant from "./images/quantification.png";
import React from "react";
import {Colors} from "../../../resources/Colors";

function AnalysisSetting() {
    return <>
        <Grid container className={"base-container"}>
            <Grid container className={"base-row"}>
                <Grid item md={12} className={"base-column title-column"}>
                    <h4 style={{color: 'white'}}>Initial Set up for a defined staining protocol
                    </h4>
                </Grid>
            </Grid>
            <Grid container className={"base-row"}>
                <Grid item md={2.4} className={"base-column laboratory"}><p><span style={{fontWeight: "bold"}}> Staining and flow cytometry </span> of
                    blood cells from multiple samples of reference group
                    (n=20 to 30)
                </p></Grid>
                <Grid item md={2.4} className={"base-column bioretis"}><p><span style={{fontWeight: "bold"}}> AI-based automated multidimensional clustering </span> of
                    cells of each sample with immunoClust
                </p></Grid>
                <Grid item md={2.4} className={"base-column bioretis"}><p><span
                    style={{fontWeight: "bold"}}> Meta-clustering </span> of all populations from all samples to
                    identify comparable clusters
                </p></Grid>
                <Grid item md={2.4} className={"base-column bioretis"}><p><span
                    style={{fontWeight: "bold"}}> Annotation </span> of relevant populations
                </p></Grid>
                <Grid item md={2.4} className={"base-column bioretis"}><p><span style={{fontWeight: "bold"}}> Quantification of cell types </span> by
                    absolute and relative numbers and definition of reference values
                </p></Grid>
            </Grid>
            <Grid container className={"base-row"}>
                <Grid item md={2.4} className={"base-column laboratory image-grid-item"}><img
                    className={"grid-image-uniform"} src={fcs} alt="FCS-Upload" width={"auto"}/></Grid>
                <Grid item md={2.4} className={"base-column image-grid-item"}>
                    <i className={"fa-regular fa-arrow-right arrow-right"}></i>
                    <img className={"grid-image-uniform"} src={clustering} alt="Cluster"
                         width={"auto"}/></Grid>
                <Grid item md={2.4} className={"base-column image-grid-item"}>
                    <i className={"fa-regular fa-arrow-right arrow-right"}></i>
                    <img className={"grid-image-uniform"}
                         src={meta} alt="Meta-Cluster"
                         width={"auto"}/></Grid>
                <Grid item md={2.4} className={"base-column image-grid-item"}>
                    <i className={"fa-regular fa-arrow-right arrow-right"} style={{paddingRight: '1rem'}}></i>
                    <img className={"grid-image-uniform"}
                         src={anno} alt="Annotation"
                         width={"auto"}/></Grid>
                <Grid item md={2.4} className={"base-column image-grid-item"}>
                    <i className={"fa-regular fa-arrow-right arrow-right"}></i>
                    <img className={"grid-image-uniform"}
                                                                                   src={quant} alt="Quantification"
                                                                                   width={"auto"}/></Grid>

            </Grid>
            <Grid container className={"base-row"}>
                <Grid item md={12} className={"base-column title-column"} style={{borderRadius: '0'}}><h4
                    style={{color: 'white'}}>Automated analysis of individual samples
                </h4></Grid>
            </Grid>
            <Grid container className={"base-row"}>
                <Grid item md={2.4} className={"base-column laboratory"}><p><span style={{fontWeight: "bold"}}>Staining, flow cytometry </span>of
                    an individual sample and data upload by client i.e. clinical laboratory
                </p></Grid>
                <Grid item md={2.4} className={"base-column bioretis"}><p><span style={{fontWeight: "bold"}}>Automated multidimensional clustering</span>
                    of cells with AI-tool immunoClust
                </p></Grid>
                <Grid item md={2.4} className={"base-column bioretis"}><p><span style={{fontWeight: "bold"}}>Automated Meta-clustering</span>
                    of all populations against reference model to identify annotated clusters
                </p></Grid>
                <Grid item md={2.4} className={"base-column bioretis"}></Grid>
                <Grid item md={2.4} className={"base-column bioretis"}><p><span style={{fontWeight: "bold"}}>Automated quantification</span>
                    of cell types by absolute and relative numbers and comparison to reference values
                </p></Grid>
            </Grid>
            <Grid container className={"base-row"}>
                <Grid item md={2.4} className={"base-column laboratory"}
                      style={{flexDirection: "row", justifyContent: "flex-end", alignItems: "center"}}>
                    <h4 style={{color: Colors.bioretisBlue}}>Laboratory</h4>
                    <i className={"fa-regular fa-left"}
                       style={{color: Colors.bioretisBlue, fontSize: "2rem", paddingLeft: "1rem"}}></i>
                </Grid>
                <Grid item md={9.6} className={"base-column bioretis"}
                      style={{flexDirection: "row", justifyContent: "flex-start", alignItems: "center"}}>
                    <i className={"fa-regular fa-right"}
                       style={{color: Colors.bioretisBlue, fontSize: "2rem", paddingRight: "1rem"}}></i>
                    <h4 style={{color: Colors.bioretisBlue}}>BioRetis</h4>
                </Grid>
            </Grid>
        </Grid>

    </>
}

export default AnalysisSetting;